import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-campaign-checkbox',
  templateUrl: './campaign-checkbox.component.html',
  styleUrls: ['./campaign-checkbox.component.scss'],
  standalone: false,
})
export class CampaignCheckboxComponent {
  @Input() checked = false;
  @Input() disabled = false;
}
